import { Link, useLocation } from "react-router-dom"; 
import estilos from "../MenuNav/MenuNav.module.css";  

function MenuLink(props) {
    const localizacao = useLocation();  // Obtém a localização atual da rota
    return (
        <Link to={props.to}  // Define o destino da navegação
            className={`${estilos.link} ${localizacao.pathname === props.to ? estilos.linkAtivo : ''}`}>
            {props.children}  {/* Renderiza o nome do link */}
        </Link>
    );
}

export default MenuLink;
